import styled from "styled-components";
import { BLACK_212121, GRAY_838383 } from "../../../../constants/colors";
import Text from "../../../common/Text";

export const Container = styled.div``;

export const ContainerNtoFound = styled.div`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
`;

export const ContainerStyleList = styled.div`
  z-index: 100;
  height: auto;
  width: 100%;
  padding-bottom: 16px;
`;

export const StyleList = styled.div`
  overflow: auto;
  max-height: calc(100vh - 48px - 32px - 16px - 34px);
  height: auto;
  background-color: white;
  border-radius: 0.75rem;
  margin-left: 16px;
  margin-right: 16px;
  padding-top: 0rem;
  padding-bottom: 0rem;

  ::-webkit-scrollbar {
    display: none;
    width: 0 !important;
  }
  scrollbar-width: none; /* Firefox */
  -ms-overflow-style: none; /* IE 10+ */

  & .MuiTypography-body1 {
    color: ${BLACK_212121};
    font-weight: 600;
    line-height: 1.495rem;
  }

  & .MuiTypography-body2 {
    color: ${GRAY_838383};
    font-size: 0.875rem;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
  z-index: 100;
`;

export const TextNotFound = styled(Text)`
  text-align: center;
`;
